import React from 'react';
import logo from '../../Images/logo.png';
import logo2 from '../../Images/logo-dark.png';

export default function Dev(props){
    const {theme} = props;
    return(
        <div className="dev">
            <img src={theme.mode === 'light' ? logo : logo2} className="dev-logo" />
            <h4 className="dev-head">This page is currently</h4>
            <h4 className="dev-head bot">Under Development</h4>
        </div>
    )
}